import { render, staticRenderFns } from "./_SizeSelect.vue?vue&type=template&id=7b5dc75d"
import script from "./_SizeSelect.vue?vue&type=script&lang=js"
export * from "./_SizeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports